import { withInstall } from '@tni-plus/utils'

import Icon from './src/Icon.vue'
export const TpIcon = withInstall(Icon)
export default TpIcon

export * from './src/icon'
export type { IconInstance } from './src/instantce'
